import { render, staticRenderFns } from "./Cancelrecall.vue?vue&type=template&id=0f31cb5c&"
import script from "./Cancelrecall.vue?vue&type=script&lang=js&"
export * from "./Cancelrecall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports